import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import getProgression from '../../services/getProgression';

// Services
import redirectToCurrent from '../../services/redirectToCurrent';

// Components
import Questionnaire from '../Questionnaire/Questionnaire';

const Chapter1 = () => {
  const history = useHistory();

  const [currentQuestion, setCurrentQuestion] = useState(getProgression('currentQuestion'));

  useEffect(() => {
    if (redirectToCurrent(1)) {
      history.push(redirectToCurrent(1));
    }
  }, []);

  return (
    <Questionnaire currentQuestion={+currentQuestion} setCurrentQuestion={setCurrentQuestion} currentChapter={1} />
  );
};

export default Chapter1;
